import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import {
  AppBar,
  Box,
  useTheme,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  ThemeProvider,
  Toolbar,
  Typography,
} from '@mui/material';
import Logo from '../../image/logo.png';
import { LANGUAGE_EN, LANGUAGE_RUS } from '../../constant/constants';
import { ThemeToggle } from '../UI/ThemeToggle';

export const SignNavigationBar = () => {
  const theme = useTheme();
  const [anchorMenu, setAnchorMenu] = useState<null | HTMLElement>(null);
  const shouldOpenMenu = Boolean(anchorMenu);
  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorMenu(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };
  const { i18n } = useTranslation();
  const selectLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
    handleCloseMenu();
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <ThemeProvider theme={theme}>
        <AppBar position="static">
          <Toolbar sx={{ justifyContent: 'space-between', gap: 1 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <img alt="" src={Logo} />
              <Stack direction="row" alignItems="center" spacing={0}>
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontStyle: 'revert',
                    fontWeight: 750,
                    fontSize: '28px',
                    color: '#FFFFFF',
                  }}
                  component="text"
                >
                  Про
                </Typography>
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontStyle: 'normal',
                    fontWeight: 100,
                    fontSize: '28px',
                    color: '#FFFFFF',
                  }}
                  component="text"
                >
                  НЕО
                </Typography>
              </Stack>
              {false && (
                <IconButton
                  id="basic-button"
                  aria-controls={shouldOpenMenu ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={shouldOpenMenu ? 'true' : undefined}
                  onClick={handleClickMenu}
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2 }}
                >
                  <LanguageIcon />
                </IconButton>
              )}
              <Menu
                id="basic-menu"
                anchorEl={anchorMenu}
                open={shouldOpenMenu}
                onClose={handleCloseMenu}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={() => selectLanguage(LANGUAGE_RUS)}>
                  Русский
                </MenuItem>
                <MenuItem onClick={() => selectLanguage(LANGUAGE_EN)}>
                  English
                </MenuItem>
              </Menu>
            </Stack>
            <ThemeToggle />
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
};
